// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Agenda_DeletaCompromissoServicoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /agenda/deleta_compromisso_servico
 *
 * Deletes a compromisso_servico record and recalculates the compromisso total.
 * Also updates the related orcamento_servico status.
 *
 * Data shape: boolean true on success
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Agenda_DeletaCompromissoServicoResponseDados = boolean;

export type Agenda_DeletaCompromissoServicoResponse = ApiResponse<Agenda_DeletaCompromissoServicoResponseDados>;

registerResponseContract('Agenda_DeletaCompromissoServicoResponse', {})
